<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">亦廉课堂></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>王立山：坚持不懈一体推进不敢腐、不能腐、不想腐</h1>
                <h2><span class="mg-16">来源：新华社</span>|<span class="mg-16">发布时间：2020-03-30&nbsp;13:30</span></h2>

        <h3>习近平总书记在十九届中央纪委四次全会上强调,一体推进不敢腐、不能腐、不想腐，不仅是反腐败斗争的基本方针，也是新时代全面从严治党的重要方略。这一重要论述是对党的十八大以来党风廉政建设和反腐败斗争经验的科学总结，是对全面从严治党规律认识的不断深化，是党的建设理论的重大创新。我们要坚定不移、坚持不懈落实一体推进“三不”的重要方略，不断取得全面从严治党更大战略性成果。</h3>
        <h3>
          <b>把“严”的主基调长期坚持下去，并贯穿一体推进“三不”</b>
        </h3>
        <h3>始终勇于自我革命，从严管党治党，是我们党最鲜明的品格，也是我们党最大的优势。党的十八大以来，党中央坚持全面从严治党，把严的要求、严的措施贯穿于管党治党全过程、各方面，取得了历史性、开创性成就，产生了全方位、深层次影响。</h3>
        <h3>新冠肺炎疫情发生以来，习近平总书记亲自指挥、亲自部署疫情防控工作，党中央一声令下，全党全军全国各族人民闻令而动、团结一心、众志成城，为全面打赢疫情防控人民战争、总体战、阻击战汇聚磅礴力量。我们党在战“疫”中所体现出的强大领导力、组织力、凝聚力、战斗力，是与党的十八大以来全面从严治党分不开的。湖北各级纪检监察机关坚决贯彻落实习近平总书记关于疫情防控工作的重要讲话和重要指示批示精神，紧紧围绕贯彻落实党中央关于疫情防控重大决策部署，以战时状态开展“火线”监督，严明战时纪律、严查战时作风、严督战时责任，对临阵退缩、作风飘浮、履职不力等失职失责和违规违纪问题坚决开刀亮剑。推动各级领导干部认真履行职责，抓紧抓实抓细各项防控工作，为打赢湖北保卫战、武汉保卫战提供有力保障。实践再次证明，全面从严治党是我们党经受各种风浪考验、战胜各种困难和挑战的政治保障。</h3>
        <h3>一体推进“三不”，就必须坚持把“严”的主基调贯穿其中。只有“严”的措施、“严”的氛围、“严”的态势，才会有“不敢”，才可能实现“不能”“不想”。所谓“严”，不是部分，而是全面；不是一时，而是永远；不是孤立的，而是系统的，必须全面从严、始终从严、永远从严。换言之，不仅对腐败分子的查处要严，对广大党员干部的日常教育、管理、监督也都要从严，切实把“严紧硬”的要求体现在管党治党的方方面面。</h3>
        <h3>
          <b>始终保持惩治腐败高压态势不动摇，持续强化不敢腐的震慑</b>
        </h3>

        <h3>惩治是反腐败斗争最有力的手段。离开了惩治，教育、管理、监督就会软弱无力，制度机制就会成为“纸老虎”“稻草人”。只有持续强化不敢腐的震慑，才能为不能腐、不想腐打牢基础。</h3>
        <h3>保持惩治腐败高压态势不是“过去时”，也没有“转段论”，只要存在腐败问题，永远都是“进行时”。当前，反腐败斗争虽然取得了压倒性胜利，但还不是彻底胜利，形势依然严峻复杂。因此，必须始终牢记习近平总书记强调的“三个不能有”，保持战略定力，坚持力度不减、尺度不松、节奏不变，以坚如磐石的决心、信心和执着、韧劲，把反腐败斗争进行到底。</h3>
        <h3>“老虎”要打，“苍蝇”也要拍。近年来，湖北各级纪检监察机关持续开展扶贫领域腐败和作风问题专项治理，创新运用“扶贫领域政策落实监察系统”开展监督检查，重拳整治“蝇贪”。2019年全省查处扶贫领域腐败和作风问题8466个、处理11117人。今年是决胜全面小康、决战脱贫攻坚的最后一年,我省还有5.8万贫困人口。收官之际又遭受新冠肺炎疫情影响，如期脱贫的难度更大。各级纪检监察机关要拧紧发条，尽锐出战，持续加强对落实党中央脱贫攻坚决策部署的监督检查，对贪污侵占、截留挪用、虚报冒领、吃拿卡要、优亲厚友等腐败问题严惩不贷，坚决斩断伸向扶贫资金的“黑手”，对弄虚作假、敷衍应付、消极拖延等形式主义、官僚主义问题坚决查处，为决战决胜脱贫攻坚提供坚强保障。</h3>
        <h3>
          <b>强化权力运行监督，扎紧织密不能腐的笼子</b>
        </h3>
        <h3>腐败的本质是权力滥用、以权谋私。加强反腐败斗争，就必须强化对权力运行的制约和监督，让胆敢腐败者无任何可乘之机、可钻之洞。深化以案促改，堵塞制度漏洞。纪检监察机关既要严肃查处案件，也要做好“后半篇文章”，针对案件暴露出的问题和漏洞，及时向有关地方、部门党委（党组）发出纪检监察建议，提出加强权力监督、完善管理制度、强化责任落实等要求，以案促改、以案促建、以案促治。</h3>
        <h3>加强对“关键少数”的严格监督。各级纪委监委既要自觉接受党委统一领导，又要积极探索加强同级监督，特别是对“一把手”的监督。要充分运用谈话提醒、受理信访举报、参加或列席民主生活会、督促巡视巡察整改、向上级纪委报告问题线索等方法措施，把监督落实落地，并形成常态化机制。</h3>
        <h3>加强对“三集”部门、领域和行业权力运行的严格监督。聚焦权力集中、资金密集、资源富集等容易滋生腐败的部门、领域、行业加强监督，坚决防止权力滥用、权力寻租。</h3>
        <h3>
          <b>加强思想道德和党纪国法教育，不断增强不想腐的自觉</b>
        </h3>
        <h3>全面从严治党、有效防治腐败，既要用好施药动刀的治病之法，又要用好固本培元的强身之举，通过加强理想信念和党纪国法教育，提升党性觉悟，培育廉洁文化，夯实“不忘初心、牢记使命”的思想根基。</h3>
        <h3>加强“以案五说”警示教育。警示教育必须要有针对性和震慑力，不能让党员干部成为“看戏”的局外人、旁观者。湖北省纪委监委对查办的违纪违法案件认真做好处分决定宣布工作，由纪检监察机关领导班子成员带队到案发地方、单位宣布处分决定，现场开展“以案五说”，即说纪、说法、说德、说害、说责，用身边事教育身边人，努力让每一名党员知敬畏、知镜鉴，从不敢腐内化为不想腐。</h3>
        <h3>推动党章党规党纪和监察法规宣传教育“十进十建”。党章党规党纪和监察法规具有教育、约束、惩戒、指引等综合功能，是串联起“三不”的一条“主线”。我们抓住这条“主线”，在全省开展“十进十建”活动，即宣传教育活动进党委（党组）、进党政机关、进民主党派和群团组织、进党校、进学校医院、进国企、进社区、进村庄、进报刊媒体、进互联网，用干部群众喜闻乐见的形式，广泛撒播廉洁文化的种子，营造遵纪守法浓厚氛围。</h3>
        <h3>运用好监督执纪“四种形态”。尤其要用好“第一种形态”，抓早、抓小、抓苗头，通过及时谈话提醒、批评教育等方式，加强经常性的思想政治和纪法警示教育，防止由小过错演化成严重违纪违法乃至“阶下囚”。</h3>
        <h3>
          <b>坚持全党全社会齐抓共治，打好反腐败斗争总体战</b>
        </h3>
        <h3>腐败问题是党内和社会各方面消极因素的综合反映。只有全党全社会齐心协力，一体推进“三不”，才能取得反腐败斗争决定性胜利，进而实现海晏河清、朗朗乾坤。</h3>
        <h3>加快构建和完善一体推进“三不”体制机制,是党的十九届四中全会确定的一项重要任务。我省基本思路及框架是：党委统一领导、人大立法监督、政府廉洁行政、纪委监委专责监督、党政部门履职尽责推进本部门本系统党风廉政建设和行业监管、民主党派和群众团体廉洁自律并共同参与反腐、基层和行业党组织及群众性自治组织廉洁自律并共同参与反腐，党内监督和各类监督紧密协同，既各尽其责、又齐抓共治，形成惩处、防范、文宣、教育、管理、监督、整改、建制等环环相扣、多措并举、标本兼治的体制机制和工作格局。</h3>
        <h3>各级党委（党组）要扛起全面从严治党主体责任，做到守土有责、守土负责、守土尽责，对一体推进“三不”既加强领导又组织施工，一体考虑经济社会发展与全面从严治党，同步推进深化改革与防治腐败，抓好党建、带好班子、管住队伍。</h3>
        <h3>一体推进“三不”，对纪检监察机关和纪检监察干部提出了新的更高标准和要求。要进一步提高政治站位，加强政治历练、实践锻炼、专业训练，努力做到德才兼备、文武兼备、攻防兼备、智勇兼备、纪法皆通，锤炼一支忠诚干净担当的高素质专业化纪检监察队伍，为深入推进新时代全面从严治党作出应有贡献。</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/ylkt5-1.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
   padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
img {
  margin: 20px 0;
}
.mg-16{
  margin: 0px 16px;
}
</style>